import { DayTypeAPI } from '../../../api/datamanager/DayTypeAPI';

export class DayTypesCommand {
    getAll(provider, successCallback, errorCallback) {
        const apiResult = DayTypeAPI.list(provider);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Tipos de Dia");
            }
        });
    }

    save(data, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(0 === data.id) {
            apiResult = DayTypeAPI.create(data);
            successMessage = "Tipo de Dia criado com sucesso";
        }
        else {
            apiResult = DayTypeAPI.update(data.id, data);
            successMessage = "Tipo de Dia editado com sucesso";
        }
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback(successMessage);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    setOrder(data, successCallback, errorCallback) {
        const apiResult = DayTypeAPI.setOrder(data.map(item => { return { id: item.id, order: item.order }; }));
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Prioridade dos Tipos de Dia actualizada com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(dataId, successCallback, errorCallback) {
        const apiResult = DayTypeAPI.delete(dataId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Tipo de Dia eliminado com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/DayTypesCommand.js